import { useEffect, useState } from "react";
import { api, fmtMoney, today, daysAgo } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import { Input } from "@/components/ui/input";

export default function SalesByCustomer() {
    const [from, setFrom] = useState(daysAgo(180));
    const [to, setTo] = useState(today());
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/reports/sales-by-customer", { params: { date_from: from, date_to: to } }).then(({ data }) => setData(data)); }, [from, to]);
    return (
        <>
            <PageHeader kicker="REPORTS • RECEIVABLES" title="Sales by Customer" subtitle="Revenue concentration by customer."
                actions={<><Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="w-[140px]" /><Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="w-[140px]" /></>} />
            <PageBody>
                <div className="bg-card border border-border rounded-md overflow-hidden">
                    {data && <table className="fin-table">
                        <thead><tr><th>Customer</th><th className="num">Invoices</th><th className="num">Total</th><th className="num">Paid</th><th className="num">Balance</th></tr></thead>
                        <tbody>{data.rows.map((r) => (<tr key={r.customer_id}><td className="font-medium">{r.customer_name}</td><td className="num">{r.invoices}</td><td className="num">{fmtMoney(r.total)}</td><td className="num">{fmtMoney(r.paid)}</td><td className="num">{fmtMoney(r.balance)}</td></tr>))}</tbody>
                    </table>}
                </div>
            </PageBody>
        </>
    );
}
